<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center"><h1>Отправка сообщений</h1></div>
    </v-app-bar>
    <v-main>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-select
                v-model="categorySelect"
                :items="categorys"
                item-text="NAME"
                item-value="ID"
                label="Воронка"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="stageSelect"
                :items="stages"
                item-text="NAME"
                item-value="STATUS_ID"
                label="Стадия сделки"
                outlined
                multiple
              ></v-select>
            </v-col>
          </v-row>
          <v-btn
            color="success"
            class="mr-4"
            @click="getDeal"
            :disabled="loading"
          >
            Сформировать
          </v-btn>
          <v-btn
            color="orange"
            class="mr-4"
            @click="sendMail"
            :disabled="loading || contacts.length <= 0"
          >
            Отправить сообщения
          </v-btn>
        </v-container>
      </v-form>
      <template v-if="loading === true">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
          color="light-green darken-4"
          height="10"
        ></v-progress-linear>
      </template>
      <template v-if="contacts.length > 0">
        <v-form>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-textarea
                  v-model="sendText"
                  label="Текст сообщения"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <v-card v-if="contacts.length > 0">
        <v-data-table
          :headers="headers"
          :items="contacts"
          :items-per-page="5"
          class="elevation-1"
          no-data-text="Нет контактов"
          :footer-props="{
            'items-per-page-all-text': 'Все',
            'items-per-page-text': 'Контактов на стр.: ',
          }"
        >
          <template #[`item.actions`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "App",
  data: () => ({
    loading: false,
    menu: false,
    categorys: [],
    categorySelect: "",
    stages: [],
    stageSelect: [],
    parametrs: [],
    sendText: "",
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "ID", value: "id" },
      { text: "ФИО", value: "name" },
      { text: "Телефон", value: "phone" },
    ],
    contacts: [],
    url: "https://engeocentr.bitrix24.ru/rest/839/wnal269dpe5j3ew9/",
    urlBX: '',
    auth: {},
    domen: "",
  }),
  methods: {
    deleteItem(item) {
      //console.log({item})
      const deletIndex = this.contacts.indexOf(item);
      this.contacts.splice(deletIndex, 1);
    },
    async getDeal() {
      try {
        this.loading = true;
        console.log("get deal");
        let start = 0;
        let isTrue = true;
        const deals = [];
        while (isTrue) {
          const paramsGetDeals = {
            filter: {
              CATEGORY_ID: this.categorySelect,
              STAGE_ID: this.stageSelect,
            },
            select: ["ID"],
            start,
          };
          const dealsData = await axios.post(
            this.url + "crm.deal.list",
            paramsGetDeals
          );
          deals.push(...dealsData.data.result);
          if (dealsData.data.next) {
            start = dealsData.data.next;
          } else {
            isTrue = false;
          }
        }
        //get contacts
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        const contacts = [];

        for (const index in deals) {
          batchParams.cmd[
            `getContact_${index}`
          ] = `crm.deal.contact.items.get?id=${deals[index].ID}`;
          if (index % 50 == 0 || Number(index) + 1 == deals.length) {
            const batchResult = await axios.post(
              this.url + "batch",
              batchParams
            );
            for (const batchIndex in batchResult.data.result.result) {
              contacts.push(...batchResult.data.result.result[batchIndex]);
            }
            batchParams.cmd = {};
          }
          await this.pause(50);
        }

        for (const index in contacts) {
          batchParams.cmd[
            `contact_${index}`
          ] = `crm.contact.get?id=${contacts[index].CONTACT_ID}`;
          if (index % 50 == 0 || Number(index) + 1 == contacts.length) {
            const batchResult = await axios.post(
              this.url + "batch",
              batchParams
            );
            console.log({ batchResult });
            for (const batchIndex in batchResult.data.result.result) {
              this.contacts.push({
                id: batchResult.data.result.result[batchIndex].ID,
                name:
                  batchResult.data.result.result[batchIndex].LAST_NAME +
                  " " +
                  batchResult.data.result.result[batchIndex].NAME +
                  " " +
                  batchResult.data.result.result[batchIndex].SECOND_NAME,
                phone:
                  batchResult.data.result.result[batchIndex].PHONE[0].VALUE,
              });
            }
            batchParams.cmd = {};
          }
          await this.pause(50);
        }
        console.log(this.contacts);
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    async sendMail() {
      try {
        this.loading = true;
        //console.log(this.sendText)
        //console.log(this.senderSelect)
        //console.log(this.deals)
        for (const contact of this.contacts) {
          const methodSend = "bizproc.workflow.start";
          const paramsSend = {
            TEMPLATE_ID: 413,
            DOCUMENT_ID: ["crm", "CCrmDocumentContact", contact.id],
            PARAMETERS: {
              text: this.sendText,
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          const resultSend = await axios.post(
            this.urlBX + methodSend,
            paramsSend
          );
          console.log({ resultSend });
          await this.pause(200);
        }
        console.log("SEND END");
        await window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },
    async getFields() {
      try {
        console.log("getFields");
        //crm.category.list
        const categoryData = await axios.post(
          this.url + "crm.dealcategory.list",
          {}
        );
        console.log(categoryData);
        this.categorys = categoryData.data.result;
      } catch (e) {
        console.log(e);
      }
    },
    async getStages() {
      //crm.status.list
      const statusData = await axios.post(this.url + "crm.status.list", {
        //ENTITY_ID: "STATUS",
        filter: {
          CATEGORY_ID: this.categorySelect,
        },
      });
      this.stages = statusData.data.result;
      console.log({ statusData });
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
  },
  watch: {
    categorySelect(oldData, newData) {
      if (oldData != newData) {
        this.getStages();
      }
    },
  },
  async mounted() {
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    this.urlBX = `https://${this.auth.DOMAIN}/rest/`;
    this.domen = this.auth.DOMAIN;

    await this.getFields();
  },
};
</script>
